import { ref } from '@vue/composition-api'
import httpClient from '../http/httpClient'

export default function useMentorOffersRepository() {
  const mentorOffers = ref([])
  const totalMentorOffers = ref(0)
  const getMentorOffers = async () => {
    await httpClient.fetchMentorOffers()
      .then(response => {
        if (response.data) {
          mentorOffers.value = response.data.data
          if (response.data.meta) {
            totalMentorOffers.value = response.data.meta.pagination.total
          }
        }
      })
      .catch(() => { })
  }

  return {
    totalMentorOffers,
    mentorOffers,
    getMentorOffers,
  }
}
